<div id="error-container-{{ fieldName }}" class="error-container" [class.invisible]="!control.touched">
  <div class="error-message" *ngFor="let item of listError">
    {{ item }}
  </div>
</div>
